











import { Component, Vue } from 'vue-property-decorator';
import { user } from '@store/modules/user';

@Component
export default class InitialsBadge extends Vue {
	get initials(): string {
		return this.hasName ? `${user.user?.firstName.charAt(0)}${user.user?.lastName.charAt(0)}` : '';
	}

	get hasName(): boolean {
		return !!user.user?.firstName && !!user.user?.lastName;
	}
}
